import React from 'react';
import { X, Type, ZoomIn } from 'lucide-react';
import { CAPTION_PRESETS } from '../lib/CaptionPresets';
import './CaptionPickerModal.css';

export const CaptionPickerModal = ({
    isOpen,
    onClose,
    onSelect,
    currentStyleId,
    includeCaptions,
    onToggleCaptions,
    captionSize,
    onSizeChange
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content caption-picker-content">
                <div className="modal-header">
                    <h3>Choose Caption Style</h3>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div className="modal-body">

                    <div className="caption-settings-section">
                        <div className="setting-row">
                            <label className="setting-label">
                                <input
                                    type="checkbox"
                                    checked={includeCaptions}
                                    onChange={onToggleCaptions}
                                />
                                <span className="setting-text">Enable Captions</span>
                            </label>
                        </div>

                        {includeCaptions && (
                            <div className="setting-row">
                                <div className="size-control">
                                    <span className="setting-text">Size: {captionSize}</span>
                                    <input
                                        type="range"
                                        min="40"
                                        max="150"
                                        value={captionSize}
                                        onChange={onSizeChange}
                                        className="modal-slider"
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="caption-styles-grid">
                        {CAPTION_PRESETS.map((preset) => (
                            <button
                                key={preset.id}
                                className={`caption-style-card ${currentStyleId === preset.id ? 'active' : ''}`}
                                onClick={() => {
                                    onSelect(preset.id);
                                    onClose();
                                }}
                            >
                                <div className="style-card-preview">
                                    {/* Render the specific visual look */}
                                    <div className="preview-container" style={{ background: preset.preview.bg === '#fff' ? '#666' : '#222' }}>
                                        <div className="preview-text-wrapper">
                                            {renderPreviewText(preset)}
                                        </div>
                                    </div>
                                </div>
                                <div className="style-card-info">
                                    <span className="style-card-name">{preset.name}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const renderPreviewText = (preset) => {
    const baseStyle = {
        fontFamily: preset.preview.fontFamily,
        fontWeight: preset.preview.fontWeight || 'normal',
        textTransform: preset.preview.textTransform || 'none',
        color: preset.preview.color,
        textShadow: preset.preview.textShadow || 'none',
        border: preset.preview.border || 'none',
        borderRadius: preset.preview.borderRadius || '0',
        padding: preset.preview.padding || '0',
        background: preset.id === 'deep_diver' ? '#fff' : 'transparent',
    };

    if (preset.id === 'default') {
        return <span style={baseStyle}>To get started</span>;
    }

    if (preset.id === 'karaoke') {
        return (
            <span style={{
                ...baseStyle,
                padding: '6px 12px',
                display: 'inline-block'
            }}>
                TO GET STARTED
            </span>
        );
    }

    if (preset.id === 'deep_diver') {
        return (
            <span style={{
                ...baseStyle,
                display: 'inline-block'
            }}>
                to get <span style={{ opacity: 0.3 }}>started</span>
            </span>
        );
    }

    // Highlight styles (Beasty, Pod P, Youshaei, Mozi)
    const hlColor = preset.preview.highlight || '#fff';

    return (
        <span style={baseStyle}>
            {preset.id === 'beasty' ? (
                <>CHOOSE A <span style={{ color: hlColor }}>STYLE</span></>
            ) : preset.id === 'pod_p' ? (
                <>GET <span style={{ color: hlColor }}>STARTED</span></>
            ) : preset.id === 'youshaei' ? (
                <>TO <span style={{ color: hlColor }}>GET STARTED</span></>
            ) : preset.id === 'mozi' ? (
                <>CHOOSE A <span style={{ color: hlColor }}>STYLE</span></>
            ) : (
                'Sample Text'
            )}
        </span>
    );
};
